export const variants = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  text: 'text',
};

export const intents = {
  primary: 'primary',
  default: 'default',
  success: 'success',
  danger: 'danger',
  warning: 'warning',
};

export const sizes = {
  small: 'small',
  middle: 'middle',
  large: 'large',
};
